import { OrigensAuthProvider } from '@origens/auth'
import { ThemeProvider, useTheme } from '@origens/ui/theme'
import type { ReactNode } from 'react'
import { publishableKey } from '../lib/auth-env.js'

function ThemedAuthProvider({ children }: { children: ReactNode }) {
  const { resolved } = useTheme()
  return (
    <OrigensAuthProvider publishableKey={publishableKey} colorScheme={resolved}>
      {children}
    </OrigensAuthProvider>
  )
}

export function AuthProviderClient({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider>
      <ThemedAuthProvider>{children}</ThemedAuthProvider>
    </ThemeProvider>
  )
}
